import React from 'react'
import {StyledComponent} from 'powtoon-components/types'
import getFileNameUrlMapping from 'powtoon-commons/NameUrlMapping'
import SVG from 'react-inlinesvg'

import './Icon.scss'

// TODO:: alt prop should not be optional, should be required
// should be changed to required after handling this all over the project

export interface IconProps extends StyledComponent {
  iconName: string,
  inlineSvg?: boolean,
  onClick?: (...args: any[]) => any,
  onLoad?: () => void
  alt?: string,
  label?: string,
  role?: string
}

const storiesRequire = () => require.context('./assets', true)
const iconsNameUrlMapping = getFileNameUrlMapping(storiesRequire)

const specificIconRules: {[key: string]: React.CSSProperties} = {
  help: {marginLeft: 1},
  home: {marginBottom: 2},
  crown: {marginLeft: -1, marginBottom: 2}
}


const Icon: React.FC<IconProps & StyledComponent> = (
  {
    iconName,
    inlineSvg,
    className,
    onLoad,
    alt,
    style: userStyle,
    label,
    role,
    ...props
  }
) => {
  const style = {
    ...(specificIconRules[iconName]),
    ...userStyle
  }

  const icon1x = iconsNameUrlMapping[iconName]
  const icon2x = iconsNameUrlMapping[`${iconName}@2x`]
  const icon3x = iconsNameUrlMapping[`${iconName}@3x`]

  let sourceSet = `${icon1x} 1x`
  if (icon2x) {
    sourceSet = `${sourceSet}, ${icon2x} 2x`
  }
  if (icon3x) {
    sourceSet = `${sourceSet}, ${icon3x} 3x`
  }
  if (inlineSvg) {
    return (
      <SVG src={iconsNameUrlMapping[iconName]} className={className} styleName="svg-icon" {...props} />
    )
  }
  return (
    <img
      src={iconsNameUrlMapping[iconName]}
      srcSet={sourceSet}
      {...props}
      styleName="icon"
      className={className}
      style={style}
      onLoad={onLoad}
      alt={alt}
      aria-label={label}
      role={role}
    />
  )
}

export default Icon
